module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-21.9155baf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-21.jpg
// module id = 5S49
// module chunks = 51